import { TransactionTypeShort } from "ts/types/Transaction"

import { suggestedItems } from "./DialogAddSuggested.config"

export const getOptions = (variant: TransactionTypeShort) =>
  suggestedItems[variant]
